/**
 * 批量CSV导出工具
 * 根据年度数据配置，批量生成和导出CSV文件
 */

import { saveAs } from 'file-saver';
import { 
  generateOrderCsvData,
  generateOrderRowObject,
  sortOrdersByTime,
  convertOrderToCsvRow
} from './generateOrderCsv';

/**
 * 年度数据配置
 * 根据用户提供的表格数据
 */
export const YEAR_DATA_CONFIG = {
  2022: {
    months: {
      7: { totalCourseOrders: 1500, price9_9: 938, price99: 351, price199: 141, price1680: 47, price2480: 23, coachOrders: 1200, storeOrders: 300, memberOrders: 38 },
      8: { totalCourseOrders: 1800, price9_9: 1125, price99: 421, price199: 169, price1680: 56, price2480: 29, coachOrders: 1440, storeOrders: 360, memberOrders: 45 },
      9: { totalCourseOrders: 2000, price9_9: 1250, price99: 468, price199: 188, price1680: 62, price2480: 32, coachOrders: 1600, storeOrders: 400, memberOrders: 50 },
      10: { totalCourseOrders: 2200, price9_9: 1375, price99: 515, price199: 207, price1680: 68, price2480: 35, coachOrders: 1760, storeOrders: 440, memberOrders: 55 },
      11: { totalCourseOrders: 2300, price9_9: 1438, price99: 538, price199: 216, price1680: 71, price2480: 37, coachOrders: 1840, storeOrders: 460, memberOrders: 58 },
      12: { totalCourseOrders: 2200, price9_9: 1375, price99: 515, price199: 207, price1680: 68, price2480: 35, coachOrders: 1760, storeOrders: 440, memberOrders: 55 }
    }
  },
  2023: {
    months: {
      1: { totalCourseOrders: 5500, price9_9: 3438, price99: 1287, price199: 517, price1680: 171, price2480: 87, coachOrders: 4400, storeOrders: 1100, memberOrders: 138 },
      2: { totalCourseOrders: 5800, price9_9: 3625, price99: 1357, price199: 545, price1680: 180, price2480: 93, coachOrders: 4640, storeOrders: 1160, memberOrders: 145 },
      3: { totalCourseOrders: 6100, price9_9: 3813, price99: 1427, price199: 573, price1680: 189, price2480: 98, coachOrders: 4880, storeOrders: 1220, memberOrders: 153 },
      4: { totalCourseOrders: 6400, price9_9: 4000, price99: 1498, price199: 602, price1680: 198, price2480: 102, coachOrders: 5120, storeOrders: 1280, memberOrders: 160 },
      5: { totalCourseOrders: 6800, price9_9: 4250, price99: 1591, price199: 639, price1680: 211, price2480: 109, coachOrders: 5440, storeOrders: 1360, memberOrders: 170 },
      6: { totalCourseOrders: 7200, price9_9: 4500, price99: 1685, price199: 677, price1680: 223, price2480: 115, coachOrders: 5760, storeOrders: 1440, memberOrders: 180 },
      7: { totalCourseOrders: 7600, price9_9: 4750, price99: 1778, price199: 714, price1680: 236, price2480: 122, coachOrders: 6080, storeOrders: 1520, memberOrders: 190 },
      8: { totalCourseOrders: 8000, price9_9: 5000, price99: 1872, price199: 752, price1680: 248, price2480: 128, coachOrders: 6400, storeOrders: 1600, memberOrders: 200 },
      9: { totalCourseOrders: 7800, price9_9: 4875, price99: 1825, price199: 733, price1680: 242, price2480: 125, coachOrders: 6240, storeOrders: 1560, memberOrders: 195 },
      10: { totalCourseOrders: 7500, price9_9: 4688, price99: 1755, price199: 705, price1680: 233, price2480: 119, coachOrders: 6000, storeOrders: 1500, memberOrders: 188 },
      11: { totalCourseOrders: 7100, price9_9: 4438, price99: 1661, price199: 667, price1680: 220, price2480: 114, coachOrders: 5680, storeOrders: 1420, memberOrders: 178 },
      12: { totalCourseOrders: 6800, price9_9: 4250, price99: 1591, price199: 639, price1680: 211, price2480: 109, coachOrders: 5440, storeOrders: 1360, memberOrders: 170 }
    }
  },
  2024: {
    months: {
      1: { totalCourseOrders: 7200, price9_9: 4500, price99: 1685, price199: 677, price1680: 223, price2480: 115, coachOrders: 5760, storeOrders: 1440, memberOrders: 180 },
      2: { totalCourseOrders: 6800, price9_9: 4250, price99: 1591, price199: 639, price1680: 211, price2480: 109, coachOrders: 5440, storeOrders: 1360, memberOrders: 170 },
      3: { totalCourseOrders: 7500, price9_9: 4688, price99: 1755, price199: 705, price1680: 233, price2480: 119, coachOrders: 6000, storeOrders: 1500, memberOrders: 188 },
      4: { totalCourseOrders: 7800, price9_9: 4875, price99: 1825, price199: 733, price1680: 242, price2480: 125, coachOrders: 6240, storeOrders: 1560, memberOrders: 195 },
      5: { totalCourseOrders: 8000, price9_9: 5000, price99: 1872, price199: 752, price1680: 248, price2480: 128, coachOrders: 6400, storeOrders: 1600, memberOrders: 200 },
      6: { totalCourseOrders: 7600, price9_9: 4750, price99: 1778, price199: 714, price1680: 236, price2480: 122, coachOrders: 6080, storeOrders: 1520, memberOrders: 190 },
      7: { totalCourseOrders: 7200, price9_9: 4500, price99: 1685, price199: 677, price1680: 223, price2480: 115, coachOrders: 5760, storeOrders: 1440, memberOrders: 180 },
      8: { totalCourseOrders: 6800, price9_9: 4250, price99: 1591, price199: 639, price1680: 211, price2480: 109, coachOrders: 5440, storeOrders: 1360, memberOrders: 170 },
      9: { totalCourseOrders: 6500, price9_9: 4063, price99: 1521, price199: 611, price1680: 202, price2480: 103, coachOrders: 5200, storeOrders: 1300, memberOrders: 163 },
      10: { totalCourseOrders: 6000, price9_9: 3750, price99: 1404, price199: 564, price1680: 186, price2480: 96, coachOrders: 4800, storeOrders: 1200, memberOrders: 150 },
      11: { totalCourseOrders: 180, price9_9: 113, price99: 42, price199: 17, price1680: 6, price2480: 2, coachOrders: 144, storeOrders: 36, memberOrders: 0 },
      12: { totalCourseOrders: 150, price9_9: 94, price99: 35, price199: 14, price1680: 5, price2480: 2, coachOrders: 120, storeOrders: 30, memberOrders: 0 }
    }
  },
  2025: {
    months: {
      1: { totalCourseOrders: 160, price9_9: 100, price99: 37, price199: 15, price1680: 5, price2480: 3, coachOrders: 128, storeOrders: 32, memberOrders: 0 },
      2: { totalCourseOrders: 140, price9_9: 88, price99: 33, price199: 13, price1680: 4, price2480: 2, coachOrders: 112, storeOrders: 28, memberOrders: 0 },
      3: { totalCourseOrders: 150, price9_9: 94, price99: 35, price199: 14, price1680: 5, price2480: 2, coachOrders: 120, storeOrders: 30, memberOrders: 0 },
      4: { totalCourseOrders: 180, price9_9: 113, price99: 42, price199: 17, price1680: 6, price2480: 2, coachOrders: 144, storeOrders: 36, memberOrders: 0 },
      5: { totalCourseOrders: 160, price9_9: 100, price99: 37, price199: 15, price1680: 5, price2480: 3, coachOrders: 128, storeOrders: 32, memberOrders: 0 },
      6: { totalCourseOrders: 140, price9_9: 88, price99: 33, price199: 13, price1680: 4, price2480: 2, coachOrders: 112, storeOrders: 28, memberOrders: 0 },
      7: { totalCourseOrders: 150, price9_9: 94, price99: 35, price199: 14, price1680: 5, price2480: 2, coachOrders: 120, storeOrders: 30, memberOrders: 0 },
      8: { totalCourseOrders: 180, price9_9: 113, price99: 42, price199: 17, price1680: 6, price2480: 2, coachOrders: 144, storeOrders: 36, memberOrders: 0 },
      9: { totalCourseOrders: 160, price9_9: 100, price99: 37, price199: 15, price1680: 5, price2480: 3, coachOrders: 128, storeOrders: 32, memberOrders: 0 },
      10: { totalCourseOrders: 140, price9_9: 88, price99: 33, price199: 13, price1680: 4, price2480: 2, coachOrders: 112, storeOrders: 28, memberOrders: 0 },
      11: { totalCourseOrders: 150, price9_9: 94, price99: 35, price199: 14, price1680: 5, price2480: 2, coachOrders: 120, storeOrders: 30, memberOrders: 0 },
      12: { totalCourseOrders: 180, price9_9: 113, price99: 42, price199: 17, price1680: 6, price2480: 2, coachOrders: 144, storeOrders: 36, memberOrders: 0 }
    }
  },
  2026: {
    months: {
      1: { totalCourseOrders: 160, price9_9: 100, price99: 37, price199: 15, price1680: 5, price2480: 3, coachOrders: 128, storeOrders: 32, memberOrders: 0 },
      2: { totalCourseOrders: 140, price9_9: 88, price99: 33, price199: 13, price1680: 4, price2480: 2, coachOrders: 112, storeOrders: 28, memberOrders: 0 },
      3: { totalCourseOrders: 150, price9_9: 94, price99: 35, price199: 14, price1680: 5, price2480: 2, coachOrders: 120, storeOrders: 30, memberOrders: 0 },
      4: { totalCourseOrders: 120, price9_9: 75, price99: 28, price199: 11, price1680: 4, price2480: 2, coachOrders: 96, storeOrders: 24, memberOrders: 0 }
    }
  }
};

/**
 * 根据配置生成单月的CSV数据
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @param {Object} monthData - 月份数据配置
 * @param {Array} categories - 课程类目列表
 * @returns {string} CSV格式字符串
 */
export function generateMonthCsvData(year, month, monthData, categories = []) {
  const {
    totalCourseOrders,
    price9_9,
    price99,
    price199,
    price1680,
    price2480,
    coachOrders,
    storeOrders,
    memberOrders
  } = monthData;

  const priceDistribution = [
    { amount: 9.9, count: price9_9 },
    { amount: 99, count: price99 },
    { amount: 199, count: price199 },
    { amount: 1680, count: price1680 },
    { amount: 2480, count: price2480 }
  ];

  const options = {
    year,
    month,
    coachOrderCount: coachOrders,
    storeOrderCount: storeOrders,
    memberOrderCount: memberOrders,
    memberPrice: 698,
    priceDistribution,
    categories
  };

  return generateOrderCsvData(options);
}

/**
 * 导出单月CSV文件
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @param {Object} monthData - 月份数据配置
 * @param {Array} categories - 课程类目列表
 * @param {string} customFilename - 自定义文件名（可选）
 */
export async function exportMonthCsv(year, month, monthData, categories = [], customFilename = null) {
  const csvContent = generateMonthCsvData(year, month, monthData, categories);
  
  const filename = customFilename || `order_data_${year}_${month.toString().padStart(2, '0')}.csv`;
  
  const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, filename);
}

/**
 * 批量导出整年CSV文件（逐个下载）
 * @param {number} year - 年份
 * @param {Array} categories - 课程类目列表
 * @param {Function} onProgress - 进度回调函数 (current, total, month)
 */
export async function exportYearCsvBatch(year, categories = [], onProgress = null) {
  const yearConfig = YEAR_DATA_CONFIG[year];
  
  if (!yearConfig) {
    throw new Error(`未找到 ${year} 年的数据配置`);
  }

  const months = Object.keys(yearConfig.months).map(Number).sort((a, b) => a - b);
  const totalMonths = months.length;

  for (let i = 0; i < months.length; i++) {
    const month = months[i];
    const monthData = yearConfig.months[month];
    
    // 调用进度回调
    if (onProgress) {
      onProgress(i + 1, totalMonths, month);
    }

    // 生成该月的CSV数据
    const csvContent = generateMonthCsvData(year, month, monthData, categories);
    
    // 直接下载该月的CSV文件
    const filename = `order_data_${year}_${month.toString().padStart(2, '0')}.csv`;
    const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename);

    // 每次下载后稍微延迟，避免浏览器阻止多个下载
    if (i < months.length - 1) {
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  }

  return { year, totalMonths };
}

/**
 * 批量导出多个年份的CSV文件（逐个下载）
 * @param {Array<number>} years - 年份数组
 * @param {Array} categories - 课程类目列表
 * @param {Function} onProgress - 进度回调函数 (currentYear, totalYears, currentMonth, totalMonths, year, month)
 */
export async function exportMultipleYearsCsvBatch(years, categories = [], onProgress = null) {
  const totalYears = years.length;
  const results = [];

  for (let yearIndex = 0; yearIndex < years.length; yearIndex++) {
    const year = years[yearIndex];
    const yearConfig = YEAR_DATA_CONFIG[year];
    
    if (!yearConfig) {
      console.warn(`未找到 ${year} 年的数据配置，跳过`);
      continue;
    }

    const months = Object.keys(yearConfig.months).map(Number).sort((a, b) => a - b);
    const totalMonths = months.length;

    for (let monthIndex = 0; monthIndex < months.length; monthIndex++) {
      const month = months[monthIndex];
      const monthData = yearConfig.months[month];
      
      // 调用进度回调
      if (onProgress) {
        onProgress(yearIndex + 1, totalYears, monthIndex + 1, totalMonths, year, month);
      }

      // 生成该月的CSV数据
      const csvContent = generateMonthCsvData(year, month, monthData, categories);
      
      // 直接下载该月的CSV文件
      const filename = `order_data_${year}_${month.toString().padStart(2, '0')}.csv`;
      const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, filename);

      // 每次下载后稍微延迟
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    results.push({ year, totalMonths });
  }

  return results;
}

/**
 * 获取所有可用的年份
 * @returns {Array<number>} 年份数组
 */
export function getAvailableYears() {
  return Object.keys(YEAR_DATA_CONFIG).map(Number).sort((a, b) => a - b);
}

/**
 * 获取指定年份的所有月份
 * @param {number} year - 年份
 * @returns {Array<number>} 月份数组
 */
export function getYearMonths(year) {
  const yearConfig = YEAR_DATA_CONFIG[year];
  if (!yearConfig) return [];
  return Object.keys(yearConfig.months).map(Number).sort((a, b) => a - b);
}

/**
 * 获取指定年月的数据配置
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @returns {Object|null} 月份数据配置
 */
export function getMonthDataConfig(year, month) {
  const yearConfig = YEAR_DATA_CONFIG[year];
  if (!yearConfig || !yearConfig.months[month]) {
    return null;
  }
  return yearConfig.months[month];
}

/**
 * 计算指定年份的统计数据
 * @param {number} year - 年份
 * @returns {Object} 统计数据
 */
export function getYearStatistics(year) {
  const yearConfig = YEAR_DATA_CONFIG[year];
  if (!yearConfig) {
    return null;
  }

  const stats = {
    year,
    totalCourseOrders: 0,
    totalCoachOrders: 0,
    totalStoreOrders: 0,
    totalMemberOrders: 0,
    totalRevenue: 0,
    months: {}
  };

  const months = Object.keys(yearConfig.months).map(Number).sort((a, b) => a - b);

  months.forEach(month => {
    const monthData = yearConfig.months[month];
    const monthRevenue = 
      monthData.price9_9 * 9.9 +
      monthData.price99 * 99 +
      monthData.price199 * 199 +
      monthData.price1680 * 1680 +
      monthData.price2480 * 2480 +
      monthData.memberOrders * 698;

    stats.months[month] = {
      ...monthData,
      revenue: monthRevenue
    };

    stats.totalCourseOrders += monthData.totalCourseOrders;
    stats.totalCoachOrders += monthData.coachOrders;
    stats.totalStoreOrders += monthData.storeOrders;
    stats.totalMemberOrders += monthData.memberOrders;
    stats.totalRevenue += monthRevenue;
  });

  return stats;
}

/**
 * 根据配置生成单月的订单对象数组
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @param {Object} monthData - 月份数据配置
 * @param {Array} categories - 课程类目列表
 * @returns {Array} 订单对象数组
 */
export function generateMonthOrders(year, month, monthData, categories = []) {
  const {
    price9_9,
    price99,
    price199,
    price1680,
    price2480,
    coachOrders,
    storeOrders,
    memberOrders
  } = monthData;

  const priceDistribution = [
    { amount: 9.9, count: price9_9 },
    { amount: 99, count: price99 },
    { amount: 199, count: price199 },
    { amount: 1680, count: price1680 },
    { amount: 2480, count: price2480 }
  ];

  const priceTitleMap = {
    9.9: '体验课',
    99: '基础课包',
    199: '进阶课包',
    1680: '进阶课包',
    2480: '进阶课包'
  };

  const allOrders = [];

  // 生成教练订单
  let coachOrdersGenerated = 0;
  for (const priceConfig of priceDistribution) {
    const ratio = priceConfig.count / 1500;
    const countForCoach = Math.round(ratio * coachOrders);
    
    for (let i = 0; i < countForCoach && coachOrdersGenerated < coachOrders; i++) {
      const baseTitle = priceTitleMap[priceConfig.amount] || '课程';
      const order = generateOrderRowObject(priceConfig.amount, 'need_full', baseTitle, year, month, categories);
      allOrders.push(order);
      coachOrdersGenerated++;
    }
  }
  
  while (coachOrdersGenerated < coachOrders) {
    const randomPrice = priceDistribution[Math.floor(Math.random() * priceDistribution.length)];
    const baseTitle = priceTitleMap[randomPrice.amount] || '课程';
    const order = generateOrderRowObject(randomPrice.amount, 'need_full', baseTitle, year, month, categories);
    allOrders.push(order);
    coachOrdersGenerated++;
  }
  
  // 生成门店订单
  let storeOrdersGenerated = 0;
  for (const priceConfig of priceDistribution) {
    const ratio = priceConfig.count / 1500;
    const countForStore = Math.round(ratio * storeOrders);
    
    for (let i = 0; i < countForStore && storeOrdersGenerated < storeOrders; i++) {
      const baseTitle = priceTitleMap[priceConfig.amount] || '课程';
      const order = generateOrderRowObject(priceConfig.amount, 'study_card', baseTitle, year, month, categories);
      allOrders.push(order);
      storeOrdersGenerated++;
    }
  }
  
  while (storeOrdersGenerated < storeOrders) {
    const randomPrice = priceDistribution[Math.floor(Math.random() * priceDistribution.length)];
    const baseTitle = priceTitleMap[randomPrice.amount] || '课程';
    const order = generateOrderRowObject(randomPrice.amount, 'study_card', baseTitle, year, month, categories);
    allOrders.push(order);
    storeOrdersGenerated++;
  }
  
  // 生成会员卡订单
  for (let i = 0; i < memberOrders; i++) {
    const order = generateOrderRowObject(698, 'member', '会员卡', year, month, categories);
    allOrders.push(order);
  }

  return allOrders;
}

/**
 * 生成一年的所有订单数据并合并为一个CSV
 * @param {number} year - 年份
 * @param {Array} categories - 课程类目列表
 * @returns {string} CSV格式字符串
 */
export function generateYearCsvData(year, categories = []) {
  const yearConfig = YEAR_DATA_CONFIG[year];
  
  if (!yearConfig) {
    throw new Error(`未找到 ${year} 年的数据配置`);
  }

  const months = Object.keys(yearConfig.months).map(Number).sort((a, b) => a - b);
  const allOrders = [];

  // 收集所有月份的订单数据
  months.forEach(month => {
    const monthData = yearConfig.months[month];
    const monthOrders = generateMonthOrders(year, month, monthData, categories);
    allOrders.push(...monthOrders);
  });

  // 按时间升序排序
  const sortedOrders = sortOrdersByTime(allOrders);

  // CSV头部
  const headers = [
    'user_id',
    'source',
    'amount',
    'amount_payable',
    'flowing_no',
    'create_time',
    'finished_time',
    'rcharge_type',
    'finished',
    'status',
    'mechanism_id',
    'title',
    'type',
    'rcharge_time',
    'pay_type'
  ];

  // 构建CSV内容
  const csvRows = [headers.join(',')];

  // 将排序后的订单转换为CSV行
  sortedOrders.forEach(order => {
    csvRows.push(convertOrderToCsvRow(order));
  });

  return csvRows.join('\n');
}

/**
 * 导出单年CSV文件（包含全年数据）
 * @param {number} year - 年份
 * @param {Array} categories - 课程类目列表
 * @param {string} customFilename - 自定义文件名（可选）
 */
export async function exportYearCsv(year, categories = [], customFilename = null) {
  const csvContent = generateYearCsvData(year, categories);
  
  const filename = customFilename || `order_data_${year}.csv`;
  
  const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, filename);
}

/**
 * 批量导出多个年份的CSV文件（每年一个CSV文件）
 * @param {Array<number>} years - 年份数组
 * @param {Array} categories - 课程类目列表
 * @param {Function} onProgress - 进度回调函数 (currentYear, totalYears, year)
 */
export async function exportMultipleYearsCsv(years, categories = [], onProgress = null) {
  const totalYears = years.length;
  const results = [];

  for (let yearIndex = 0; yearIndex < years.length; yearIndex++) {
    const year = years[yearIndex];
    
    // 调用进度回调
    if (onProgress) {
      onProgress(yearIndex + 1, totalYears, year);
    }

    try {
      // 生成并导出该年的CSV
      await exportYearCsv(year, categories);
      results.push({ year, success: true });
    } catch (error) {
      console.error(`导出 ${year} 年数据失败:`, error);
      results.push({ year, success: false, error });
    }

    // 每次导出后稍微延迟
    if (yearIndex < years.length - 1) {
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  }

  return results;
}
